"use client";
export function ApplicatorFaq() {
  return (
    <section id="applicators-faq" className="py-24" data-header-scheme="light">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <h3 className="font-serif text-2xl md:text-3xl font-light mb-8 tracking-tight">
          FAQ: Microcement & Plaster Contractors
        </h3>
        <div className="space-y-6">
          <div>
            <p className="font-medium text-foreground">
              Is microcement durable enough for high traffic floors?
            </p>
            <p className="text-sm text-muted-foreground">
              Yes. When correctly layered and sealed, microcement withstands
              commercial traffic with proper maintenance.
            </p>
          </div>
          <div>
            <p className="font-medium text-foreground">Can it go over tile?</p>
            <p className="text-sm text-muted-foreground">
              Typically yes—after cleaning, de-glossing, leveling, and
              reinforcing grout lines to prevent telegraphing.
            </p>
          </div>
          <div>
            <p className="font-medium text-foreground">
              How long does installation take?
            </p>
            <p className="text-sm text-muted-foreground">
              Most residential rooms install in 2–4 days plus cure time, faster
              than full demolition and replacement.
            </p>
          </div>
          <div>
            <p className="font-medium text-foreground">Is it waterproof?</p>
            <p className="text-sm text-muted-foreground">
              The microcement layer is water resistant; full waterproof
              assemblies in showers rely on underlying membranes.
            </p>
          </div>
          <div>
            <p className="font-medium text-foreground">
              What maintenance is required?
            </p>
            <p className="text-sm text-muted-foreground">
              Neutral pH cleaners, avoid abrasives; reseal high-use floors every
              2–3 years depending on wear.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
